import { render, staticRenderFns } from "./StatusArrematanteSelect.vue?vue&type=template&id=3248f2b2&"
import script from "./StatusArrematanteSelect.vue?vue&type=script&lang=js&"
export * from "./StatusArrematanteSelect.vue?vue&type=script&lang=js&"
import style0 from "./StatusArrematanteSelect.vue?vue&type=style&index=0&id=3248f2b2&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports